'use client'

import { noop } from 'lodash'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'

import ConversationMessages from '../ConversationMessages'
import IntroMessage from '../IntroMessage'
import BaseConversationContent from './BaseConversationContent'
import SvcMessagingSuggestedMessages from './SvcMessagingSuggestedMessages'
import CoreSuggestedMessages from './CoreSuggestedMessages'
import TranslationButton from './TranslationButton'
import AutomatedResponseFeedbackModal from './AutomatedSupportFeedbackModal'
import ConversationBanners from './ConversationBanners'

type Props = {
  toggleSidebar?: () => void
  openOfferModal?: () => void
}

const ConversationContent = ({ toggleSidebar = noop, openOfferModal }: Props) => {
  const isWebMessagingSvcFeatureEnabled = useFeatureSwitch('web_messaging_svc')

  const SuggestedMessages = isWebMessagingSvcFeatureEnabled
    ? SvcMessagingSuggestedMessages
    : CoreSuggestedMessages

  return (
    <BaseConversationContent>
      <ConversationBanners />
      <IntroMessage />
      <ConversationMessages toggleSidebar={toggleSidebar} openOfferModal={openOfferModal} />
      <SuggestedMessages />
      <TranslationButton />
      <AutomatedResponseFeedbackModal />
    </BaseConversationContent>
  )
}

export default ConversationContent
